import { ASSIGNMENT_LINK_INFO, FIRST_NAME_INFO } from '@/shared/constants/copies';
import { ASSIGNMENT_LINK_VARIABLE, MessageVariableKey } from '@/shared/constants/message-constants';

const VARIABLE_SELECTOR = 'span[data-type="variable"]';

/** Browser-only, like the rest of `html-utils`. `fallback` is what the server and a parse failure return. */
function withParsedHtml<T>(html: string, fallback: T, run: (doc: Document) => T): T {
	if (typeof window === 'undefined' || !html) return fallback;

	try {
		return run(new DOMParser().parseFromString(html, 'text/html'));
	} catch (err) {
		console.error('Error parsing message HTML', err);
		return fallback;
	}
}

export function hasMessageVariable(html: string, id: MessageVariableKey): boolean {
	return withParsedHtml(
		html,
		false,
		(doc) => doc.querySelector(`${VARIABLE_SELECTOR}[data-id="${id}"]`) !== null
	);
}

/** Pill tooltip: first name and assignment link get their explainer, every other variable its own
 *  description (a workspace variable's description is its text). */
export function getMessageVariableTooltip(
	variable: { id: string; description?: string },
	firstNameTooltip: string = FIRST_NAME_INFO
): string {
	if (variable.id === 'first_name') return firstNameTooltip;
	if (variable.id === ASSIGNMENT_LINK_VARIABLE.id) return ASSIGNMENT_LINK_INFO;
	return variable.description ?? '';
}
